import Text from "@commons/Typography/Text";
import Button from "@commons/Button";
import Heading from "@commons/Typography/Heading";
import type { GeoJsonFeature } from "@typings/components/map";
import type { CameraTrapGeoJsonProperties } from "@services/device/cameraTrap/getGeoJson/type";

interface CameraTrapPopupProps {
  feature: GeoJsonFeature<CameraTrapGeoJsonProperties>;
  onNavigate: (path: string) => void;
}

function CameraTrapPopup({ feature, onNavigate }: CameraTrapPopupProps) {
  if (!feature || !feature.properties) {
    return (
      <div className="p-3">
        <Text size="sm" className="text-red-500">
          Erro ao carregar dados
        </Text>
      </div>
    );
  }

  const device = feature.properties;
  const coordinates = feature.geometry.coordinates;

  const handleNavigate = () => {
    onNavigate(`/devices/camera-trap/${device.id}`);
  };

  return (
    <div className="flex flex-col gap-3 px-2 py-1 min-w-[220px]">
      <div className="flex items-center justify-between">
        <Heading size="sm">Câmera Trap</Heading>
      </div>

      <div className="space-y-2">
        <Text size="sm" className="font-roboto">
          <span className="font-semibold">Número: </span> {device.number}
        </Text>
        <Text size="sm" className="font-roboto">
          <span className="font-semibold">Coordenadas: </span>{" "}
          {coordinates[1].toFixed(6)}, {coordinates[0].toFixed(6)}
        </Text>

        {device.responsibleTeam && (
          <Text size="sm" className="font-roboto">
            <span className="font-semibold">Equipe Responsável: </span>{" "}
            {device.responsibleTeam}
          </Text>
        )}
      </div>

      <Button
        size="auto"
        customVariant="secondary"
        className="mt-2"
        onClick={handleNavigate}
      >
        Mais Detalhes
      </Button>
    </div>
  );
}

export default CameraTrapPopup;
